// extracted by mini-css-extract-plugin
export default {"errorMsg":"FindProviderSearch_errorMsg__a9njy","mandatoryLabel":"FindProviderSearch_mandatoryLabel__EBOhI"};